import React from 'react';

export default function SpaarklesBlock() {
  return (
    <svg
      width='42'
      height='41'
      viewBox='0 0 42 41'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g filter='url(#filter0_di_4454_83221)'>
        <g clip-path='url(#clip0_4454_83221)'>
          <rect
            x='1'
            width='40'
            height='40'
            rx='12'
            fill='url(#paint0_linear_4454_83221)'
          />
          <g
            clip-path='url(#clip1_4454_83221)'
            filter='url(#filter1_dd_4454_83221)'
          >
            <path
              d='M18.9997 29.236L15.7547 22.745L9.26367 19.5L15.7547 16.255L18.9997 9.764L22.2447 16.255L28.7357 19.5L22.2447 22.745L18.9997 29.236ZM26.9997 29L28.4997 32L29.9997 29L32.9997 27.5L29.9997 26L28.4997 23L26.9997 26L23.9997 27.5L26.9997 29ZM28.3327 12.667L29.4997 15L30.6667 12.667L32.9997 11.5L30.6667 10.333L29.4997 8L28.3327 10.333L25.9997 11.5L28.3327 12.667Z'
              fill='url(#paint1_linear_4454_83221)'
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id='filter0_di_4454_83221'
          x='0.5'
          y='0'
          width='41'
          height='41'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'
        >
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='0.5' />
          <feGaussianBlur stdDeviation='0.25' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_4454_83221'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_4454_83221'
            result='shape'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='0.5' />
          <feGaussianBlur stdDeviation='0.25' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0'
          />
          <feBlend
            mode='normal'
            in2='shape'
            result='effect2_innerShadow_4454_83221'
          />
        </filter>
        <filter
          id='filter1_dd_4454_83221'
          x='-21'
          y='-18.1015'
          width='84'
          height='84'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'
        >
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='10' />
          <feGaussianBlur stdDeviation='10' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.118924 0 0 0 0 0.158031 0 0 0 0 0.570833 0 0 0 0.4 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_4454_83221'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='3.89851' />
          <feGaussianBlur stdDeviation='15' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0'
          />
          <feBlend
            mode='normal'
            in2='effect1_dropShadow_4454_83221'
            result='effect2_dropShadow_4454_83221'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect2_dropShadow_4454_83221'
            result='shape'
          />
        </filter>
        <linearGradient
          id='paint0_linear_4454_83221'
          x1='21'
          y1='0'
          x2='21'
          y2='40'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#29282C' />
          <stop offset='1' stop-color='#100F11' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_4454_83221'
          x1='9.08028'
          y1='3.06879'
          x2='26.572'
          y2='28.4254'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='white' stop-opacity='0.65' />
        </linearGradient>
        <clipPath id='clip0_4454_83221'>
          <rect x='1' width='40' height='40' rx='12' fill='white' />
        </clipPath>
        <clipPath id='clip1_4454_83221'>
          <rect
            width='24'
            height='24'
            fill='white'
            transform='translate(9 8)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}
